import React from 'react';
import styled from 'styled-components';

const FlexRow = styled.div`
  display: flex;
  
  &.wrap {
    flex-wrap: wrap;
  }
`;

export default FlexRow;
